<template>
  <div :class="data.class" class="date-block">
    {{ time }}
  </div>
</template>

<script>
export default {
  name: 'dateblock',
  props: ['data'],
  computed: {
    time() {
      return this.moment().format(this._.get(this.data, 'format', '[Stand: ]DD.MM.YYYY'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// BlockDate.vue?fffa9fca